export default ['daily', 'weekly', 'monthly', 'quarterly'];
